import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import TitledContainer from "../TitledContainer";

import styles from "./TitledLabel.css";

const TitledLabel = (props) => (
  <TitledContainer isLarge={props.isLarge} title={props.title}>
    <div className={classnames(styles.text, { [styles.large]: props.isLarge })}>{props.text}</div>
  </TitledContainer>
);

TitledLabel.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isLarge: PropTypes.bool,
};

export default TitledLabel;
